/** Phân quyền — phiếu nhập kho */
export const PHIEU_NHAP_KHO_PERMISSION_CODES = {
  WEB_BH_PHIEU_NHAP_KHO_LIST: 'WEB_BH_PHIEU_NHAP_KHO_LIST',
  WEB_BH_PHIEU_NHAP_KHO_DETAIL: 'WEB_BH_PHIEU_NHAP_KHO_DETAIL',
  WEB_BH_PHIEU_NHAP_KHO_ADD: 'WEB_BH_PHIEU_NHAP_KHO_ADD',
  WEB_BH_PHIEU_NHAP_KHO_EDIT: 'WEB_BH_PHIEU_NHAP_KHO_EDIT',
  WEB_BH_PHIEU_NHAP_KHO_DELETE: 'WEB_BH_PHIEU_NHAP_KHO_DELETE',
  WEB_BH_PHIEU_NHAP_KHO_STATUS: 'WEB_BH_PHIEU_NHAP_KHO_STATUS',
  WEB_BH_PHIEU_NHAP_KHO_IMPORT: 'WEB_BH_PHIEU_NHAP_KHO_IMPORT',
  WEB_BH_PHIEU_NHAP_KHO_EXPORT: 'WEB_BH_PHIEU_NHAP_KHO_EXPORT',
} as const

export type PhieuNhapKhoPermissionCode =
  (typeof PHIEU_NHAP_KHO_PERMISSION_CODES)[keyof typeof PHIEU_NHAP_KHO_PERMISSION_CODES]

export const PHIEU_NHAP_KHO_MUTATE_PERMISSIONS = [
  PHIEU_NHAP_KHO_PERMISSION_CODES.WEB_BH_PHIEU_NHAP_KHO_ADD,
  PHIEU_NHAP_KHO_PERMISSION_CODES.WEB_BH_PHIEU_NHAP_KHO_EDIT,
  PHIEU_NHAP_KHO_PERMISSION_CODES.WEB_BH_PHIEU_NHAP_KHO_DELETE,
  PHIEU_NHAP_KHO_PERMISSION_CODES.WEB_BH_PHIEU_NHAP_KHO_STATUS,
  PHIEU_NHAP_KHO_PERMISSION_CODES.WEB_BH_PHIEU_NHAP_KHO_IMPORT,
  PHIEU_NHAP_KHO_PERMISSION_CODES.WEB_BH_PHIEU_NHAP_KHO_EXPORT,
] as const
